import { render, staticRenderFns } from "./contract-send-contract-changed-email.vue?vue&type=template&id=15322655&"
import script from "./contract-send-contract-changed-email.vue?vue&type=script&lang=js&"
export * from "./contract-send-contract-changed-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports